module.exports = __webpack_public_path__ + "img/Metro Manila.af178c5d.jpg";